import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuth } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { apiJson } from '@/lib/api';
import type { ProfessionalClientListResponse } from '@/lib/types';

function ProClientIndexRedirect() {
  const { inviteId } = Route.useParams();
  const id = Number(inviteId);
  const navigate = useNavigate();
  const { isLoaded, isSignedIn, getToken } = useAuth();

  const clientsQuery = useQuery({
    queryKey: ['professional-clients'],
    queryFn: () => apiJson<ProfessionalClientListResponse>(getToken, '/v1/professional/clients'),
    enabled: isLoaded && !!isSignedIn,
  });

  useEffect(() => {
    if (!clientsQuery.data) return;
    const inv = clientsQuery.data.clients.find((c) => c.id === id);
    if (!inv) {
      navigate({ to: '/pro', replace: true });
      return;
    }
    if (inv.share_chats) {
      navigate({ to: '/pro/clients/$inviteId/chat', params: { inviteId }, replace: true });
      return;
    }
    if (inv.share_expenses) {
      navigate({ to: '/pro/clients/$inviteId/expenses', params: { inviteId }, replace: true });
      return;
    }
    if (inv.share_custody_calendar) {
      navigate({ to: '/pro/clients/$inviteId/calendar', params: { inviteId }, replace: true });
      return;
    }
    if (inv.share_journal) {
      navigate({ to: '/pro/clients/$inviteId/journal', params: { inviteId }, replace: true });
      return;
    }
    navigate({ to: '/pro', replace: true });
  }, [clientsQuery.data, id, inviteId, navigate]);

  return (
    <div className='flex justify-center py-12'>
      <div className='animate-spin h-8 w-8 border-2 border-[#018A9D] border-t-transparent rounded-full' />
    </div>
  );
}

export const Route = createFileRoute('/pro/clients/$inviteId/')({
  component: ProClientIndexRedirect,
});
